export const DragIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5 6.45801H2.5C2.15833 6.45801 1.875 6.17467 1.875 5.83301C1.875 5.49134 2.15833 5.20801 2.5 5.20801H17.5C17.8417 5.20801 18.125 5.49134 18.125 5.83301C18.125 6.17467 17.8417 6.45801 17.5 6.45801Z" fill="#A9A9AA"/>
      <path d="M17.5 10.625H2.5C2.15833 10.625 1.875 10.3417 1.875 10C1.875 9.65833 2.15833 9.375 2.5 9.375H17.5C17.8417 9.375 18.125 9.65833 18.125 10C18.125 10.3417 17.8417 10.625 17.5 10.625Z" fill="#A9A9AA"/>
      <path d="M17.5 14.792H2.5C2.15833 14.792 1.875 14.5087 1.875 14.167C1.875 13.8253 2.15833 13.542 2.5 13.542H17.5C17.8417 13.542 18.125 13.8253 18.125 14.167C18.125 14.5087 17.8417 14.792 17.5 14.792Z" fill="#A9A9AA"/>
    </svg>

  )
}